import React from "react";
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Toolbar, Box, AppBar, Typography } from "@mui/material";
import {
  Dashboard,
  People,
  PersonAdd,
  AppRegistration,
  HowToReg,
  CloudSync
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import Header from "./Header";
import { useAuth } from "../../context/AuthContext";

const drawerWidth = 240;

const SidebarLayout = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => setOpen(!open);

  const { currentUserData } = useAuth();
  //console.log("🔍 currentUserData:", currentUserData);
  const userRole = currentUserData?.rol;
  //console.log("🔐 userRole:", userRole);
  const canViewSidebar = Boolean(userRole);
  //console.log("📋 canViewSidebar:", canViewSidebar);

  return (
    <Box sx={{ display: "flex", transition: "margin 0.3s", ml: open ? `${drawerWidth}px` : 0 }}>
      <Drawer
        variant="temporary"
        open={open}
        onClose={toggleDrawer}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#f8f8f8",
          },
        }}
      >
        <Toolbar />
        {canViewSidebar && (
          <List
            sx={{
              mt: 4,
              "& .MuiListItemText-primary": { fontSize: "0.9rem" },
            }}
          >
            {["admin", "gestor"].includes(userRole) && (
              <ListItem button component={Link} to="/dashboard">
                <ListItemIcon>
                  <Dashboard fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>
            )}

            {["admin", "gestor", "cobranzas"].includes(userRole) && (
              <ListItem button component={Link} to="/members">
                <ListItemIcon>
                  <People fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Lista de Socios" />
              </ListItem>
            )}

            {["admin", "gestor"].includes(userRole) && (
              <ListItem button component={Link} to="/applicants">
                <ListItemIcon>
                  <HowToReg fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Solicitudes de Membresía" />
              </ListItem>
            )}

            {["admin", "gestor"].includes(userRole) && (
              <ListItem
                button
                component="a"
                href="/registration"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ListItemIcon>
                  <AppRegistration fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Registro de Aspirantes" />
              </ListItem>
            )}

            {["admin"].includes(userRole) && (
              <ListItem button component={Link} to="/admin/listUsers">
                <ListItemIcon>
                  <People fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Usuarios del Sistema" />
              </ListItem>
            )}

            {["admin"].includes(userRole) && (
              <ListItem button component={Link} to="/admin/brevo">
                <ListItemIcon>
                  <CloudSync fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Integración Brevo" />
              </ListItem>
            )}
            
            {["admin", "gestor", "cobranzas"].includes(userRole) && (
              <ListItem button component={Link} to="/account/password">
                <ListItemIcon>
                  <PersonAdd fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Cambiar Contraseña" />
              </ListItem>
            )}
          </List>
        )}
      </Drawer>

      <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <Header open={open} onToggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            transition: "margin 0.3s",
          }}
        >          
          <Toolbar />
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default SidebarLayout;
